import { modifyMutable, produce } from "solid-js/store"
import { useAuthPlayerIdSignal } from "../../../../rx/signal/useAuthPlayerIdSignal"
import { useHoveredPositionSignal } from "../../../../rx/signal/useHoveredPositionSignal"
import { useSelectedPositionSignal } from "../../../../rx/signal/useSelectedPositionSignal"
import { useSelectedToolSignal } from "../../../../rx/signal/useSelectedToolSignal"
import type { Nullable } from "../../../../typescript"
import calculateDraftMoveRangedAttackEstimates from "../../draft_move/calculateDraftMoveRangedAttackEstimates"
import createDraftMove from "../../draft_move/createDraftMove"
import type { Engine } from "../../engine/Engine.type"
import centerPanCameraToPosition from "../../entity/EntityHeading/centerPanCameraToPosition"
import type { Entity } from "../../entity/index"
import type { HasMobility } from "../../has_mobility"
import { SelectedToolId } from "../../map_editor/SelectedToolId.enum"
import type { HasPlayerId } from "../../player/has_player_id"
import toCoord from "../../tile_position_xy/toCoord"
import type { HasWaitedThisTurn } from "../../WaitedThisTurn"
import type { HasWasBuiltThisTurn } from "../../WasBuiltThisTurn"

export default function handleRotateUnitSelection(engine: Engine, forward: boolean) {
  const [, setSelectedTool] = useSelectedToolSignal(engine)
  const [, setSelectedPosition] = useSelectedPositionSignal(engine)
  const [, setHoveredPosition] = useHoveredPositionSignal(engine)

  setSelectedTool(SelectedToolId.MoveUnit)
  // console.log('handleRotateNextUnit')
  modifyMutable(engine, produce((engine : Engine) => {
    const nextUnit = getNextUnit(engine, forward)
    // console.log('nextUnit', deepClone(nextUnit))
    setHoveredPosition(null)
    setSelectedPosition(nextUnit ? toCoord(nextUnit) : null)
    engine.draftMove = nextUnit ? createDraftMove(nextUnit) : null
    calculateDraftMoveRangedAttackEstimates(engine, engine.draftMove)
    if (nextUnit) {
      centerPanCameraToPosition(engine, nextUnit)
    }
  }))
}

function getNextUnit(engine: Engine, forward: boolean): Nullable<Entity> {
  const [getAuthPlayerId] = useAuthPlayerIdSignal(engine)
  const playerId = engine.selectedPlayerId || getAuthPlayerId()
  const { draftMove, state } = engine
  const unit = draftMove?.unit
  // console.log('playerId', playerId)
  const activePlayerEnts = state.ents.filter((ent) => {
    if ((ent as HasPlayerId).player_id !== playerId) {
      return false
    }
    // console.log((ent as HasPlayerId).player_id, (ent as HasWaitedThisTurn).waitedThisTurn, (ent as HasWasBuiltThisTurn).builtThisTurn, !((ent as HasMobility).mobility > 0))
    if ((ent as HasWaitedThisTurn).waitedThisTurn) {
      return false
    }
    if ((ent as HasWasBuiltThisTurn).builtThisTurn) {
      return false
    }
    if (!((ent as HasMobility).mobility > 0)) {
      return false
    }
    return true
  })
  // console.log('activePlayerEnts', deepClone(activePlayerEnts))

  const unitIndex = unit ? activePlayerEnts.findIndex((ent) => ent.id === unit.id) : -1
  // console.log('unitIndex', deepClone(unitIndex))

  if (forward) {
    return activePlayerEnts[unitIndex + 1] || activePlayerEnts[0]
  }
  return activePlayerEnts[unitIndex - 1] || activePlayerEnts.at(-1)
}